import React from 'react';

const statusConverter = (status, relayFlag) => {
  if (relayFlag == 2) {
    return <span style={{ color: '#50bb5b' }}>● 정상</span>;
  }

  switch (status) {
    case 'none':
      return <span style={{ color: '#ececec' }}>● 미수신</span>;
    case 'danger':
      return <span style={{ color: '#ff0018' }}>● 위험</span>;
    case 'warning':
      return <span style={{ color: '#e8ad2e' }}>● 경고</span>;
    default:
      return <span style={{ color: '#50bb5b' }}>● 정상</span>;
  }
};

export const statusConverterForWhiteBackground = (status, relayFlag) => {

  if (relayFlag == 2) {
    return <span className="blue-status-text">정상</span>
  }

  switch (status) {
    case 'none':
      return <span className="none-status-text">미수신</span>;
    case 'danger':
      return <span className="danger-status-text">위험</span>;
    case 'warning':
      return <span className="warning-status-text">경고</span>;
    default:
      return <span className="blue-status-text">정상</span>;
  }
};

export default statusConverter;
